import React, { Suspense, lazy } from 'react';
import InView from './InView';
import Widget from './Widget';
import { Journey } from 'src/common/interfaces/journey.interface';

const enum WidgetHeight {
  XLarge = 588,
  Large = 472,
  Medium = 344,
  Small = 216,
}

function lazyLoadWidget(importPromise :any , loaderSize?: any) {
  const Component = lazy(importPromise);
  return (props: any) => (
    <Suspense
      fallback={
        <Widget>
          <Widget.Content status="loading" loaderSize={loaderSize} />
        </Widget>
      }
    >
      <Component {...props} />
    </Suspense>
  );
}

const KPIsWidget = lazyLoadWidget(() => import('./KpisWidget'), 80);
const BrowsersWidget = lazyLoadWidget(() => import('./BrowsersWidget'));
// const TrendWidget = lazyLoadWidget(() => import('./TrendWidget'), 40);
const TopDevicesWidget = lazyLoadWidget(() => import('./TopDevicesWidget'));
const TopSourcesWidget = lazyLoadWidget(() => import('./TopSourcesWidget'));
const TopLocationsWidget = lazyLoadWidget(() => import('./TopLocationsWidget'));

type WidgetProps ={
  journey: Journey
}

export default function Widgets({journey}: WidgetProps) {
  return (
    <div className=" grid grid-cols-2 gap-5 sm:gap-10 grid-rows-3-auto">
      <div className="col-span-2" style={{ height: WidgetHeight.XLarge }}>
        <KPIsWidget journey={journey}/>
      </div>
      <div className="col-start-1 col-span-2 lg:col-span-1 grid grid-cols-1 gap-5 sm:gap-10 grid-rows-3-auto">
        <InView height={WidgetHeight.Large}>
          <TopLocationsWidget journey={journey}/>
        </InView>
        <InView height={WidgetHeight.Large}>
          <TopSourcesWidget journey={journey}/>
        </InView>
      </div>
      <div className="col-start-1 col-span-2 lg:col-start-2 lg:col-span-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-5 sm:gap-10 grid-rows-2-auto lg:grid-rows-3-auto">
        {/* <div className="col-span-1 md:col-span-2 lg:col-span-1">
          <InView height={WidgetHeight.Large}>
            <TopSourcesWidget />
          </InView>
        </div> */}
        <InView height={WidgetHeight.Medium}>
          <TopDevicesWidget journey={journey}/>
        </InView>
        <InView height={WidgetHeight.Medium}>
          <BrowsersWidget journey={journey}/>
        </InView>
      </div>
    </div>
  );
}
